import { ModuleRequestError, describeModuleError } from '@wit-support/admin-client-core';
import { notConfiguredText } from '@wit-support/ui';
/** Ошибки раздела словами (спека §6.7). */
export const PAYBACK_SERVICE = 'Сервис рекламы auto-ads';
export const PAYBACK_ENV = ['AUTO_ADS_API_BASE_URL', 'AUTO_ADS_API_TOKEN'];
export const NOT_CONFIGURED_TEXT = notConfiguredText(PAYBACK_SERVICE, PAYBACK_ENV);
export const UNAVAILABLE_TEXT = 'Не удалось получить прогноз — повторите через минуту';
export const CONTRACT_MISMATCH_TEXT = 'Данные пришли в неожиданном формате — повторите позже; если не пройдёт, сообщите разработчикам';
/** Ответ пришёл про другой момент прогноза (`moment_mismatch`). */
export const MOMENT_MISMATCH_TEXT = 'Неожиданный ответ сервиса: пришёл прогноз другого момента — повторите';
/** Очередь отчётов auto-ads занята (503 `payback_busy`). */
export const BUSY_TEXT = 'Сервис отчётов занят, попробуйте через минуту';
export const DETAILS_OFF_TEXT = 'Нет данных';
/** Проверка раздела рекламы (`/api/ads/health`, `/api/ads/accounts`) ответила 404/503. */
export const ADS_OFF_TEXT = 'Раздел рекламы не подключён или недоступен';
export const FORBIDDEN_TEXT = 'Раздел «Реклама» недоступен вашей роли: его видят маркетинг, супервайзеры и владелец.';
export function describePaybackError(err) {
    return describeModuleError(err, 'read', {
        forbiddenRead: FORBIDDEN_TEXT,
        forbiddenWrite: FORBIDDEN_TEXT,
        notConfiguredCode: 'ads_not_configured',
        notConfiguredText: NOT_CONFIGURED_TEXT,
        unavailableText: UNAVAILABLE_TEXT,
        textOf: (e) => e.serverMessage ?? 'ошибка сервиса',
        extra: (e) => {
            if (e.code === 'contract_mismatch')
                return CONTRACT_MISMATCH_TEXT;
            if (e.code === 'moment_mismatch')
                return MOMENT_MISMATCH_TEXT;
            if (e.code === 'payback_busy')
                return BUSY_TEXT;
            if (e.code === 'payback_details_not_configured')
                return DETAILS_OFF_TEXT;
            if (e.status === 400)
                return e.serverMessage ?? 'Неверный период';
            return null;
        },
    });
}
/**
 * Раздел рекламы не подключён или недоступен: проверка подключения ответила
 * 404 (у auto-ads нет маршрута — общий обработчик сказал бы «Объект не
 * найден — возможно, он уже удалён») или 503. Не «ошибка», а состояние —
 * экран показывает спокойную плашку с «Повторить».
 */
export function isAdsOff(err) {
    return (err instanceof ModuleRequestError &&
        (err.status === 404 || err.status === 503) &&
        err.code !== 'payback_details_not_configured' &&
        err.code !== 'payback_busy');
}
/** Детализация agent API не подключена — блок просто скрывается. */
export function isDetailsOff(err) {
    return err instanceof ModuleRequestError && err.code === 'payback_details_not_configured';
}
//# sourceMappingURL=errors.js.map